import { useState } from 'react'

interface Props {
  url: string
  label?: string
}

// A URL the commissioner reads out loud, types into a TV, or hands to a phone.
//
// The URL itself is always on screen rather than hidden behind the button:
// draft night runs over plain HTTP on a LAN, where the clipboard API is
// unavailable, so the copy can fail with nothing to show for it.
export default function CopyLink({ url, label }: Props) {
  const [copied, setCopied] = useState(false)

  async function copy() {
    try {
      await navigator.clipboard.writeText(url)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      // Clipboard unavailable (http, permissions) — the URL is still visible.
    }
  }

  return (
    <div>
      {label && <p className="text-ink-mid">{label}</p>}
      <div className="mt-1 flex items-center gap-2">
        <code className="truncate rounded bg-ink px-2 py-1 text-xs text-ink-mid">{url}</code>
        <button
          type="button"
          onClick={() => void copy()}
          className="shrink-0 text-xs text-ink-mid underline-offset-2 hover:underline"
        >
          {copied ? 'Copied!' : 'Copy'}
        </button>
      </div>
    </div>
  )
}
